import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useUpsellModal } from "../../hooks/useUpsellModal.js";
const UpsellTag = ({ children, wrapperAttributes = {}, ...feature })=>{
    const { modal, tag } = useUpsellModal(feature);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsx("span", {
                ...wrapperAttributes,
                children: tag
            })
        ]
    });
};
export { UpsellTag };
